"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Separator } from "@/components/ui/separator";
interface FounderBio {
  name: string;
  role: string;
  paragraphs: string[];
  nameText?: string;
}
const founders: FounderBio[] = [{
  name: "Sharefa Bajabir-Geddes",
  role: "Founder & Director",
  paragraphs: ["Sharefa Bajabir-Geddes, MS, CID, is the Founder and Creative Director of S&L Realty and Design. Originally from Zanzibar, Tanzania, Sharefa spent her formative years in the Middle East before immigrating with her family to Canada. She earned a Bachelor of Science in Biochemistry from the University of Ottawa, later attended medical school and went on to complete a Master’s degree in Medical Informatics. Her early professional experience included work within healthcare and behavioral health, giving her a unique appreciation for the relationship between environment, well-being and the way people experience space.", "Her multidisciplinary background, international upbringing and lifelong appreciation for architecture, art and interiors have shaped a design perspective that is thoughtful, layered, deeply personal and grounded in how a space feels as much as how it looks.\xA0", "While her early career took a different path, Sharefa was always drawn to interior design and custom home renovation. After collaborating with her husband on several family projects, she chose to pursue formal training in interior design and ultimately founded S&L Realty and Design.\xA0", "Sharefa’s diverse background and extensive global travel have deeply influenced her design perspective, inspiring a layered and culturally informed approach to residential, hospitality, commercial and retail environments. Her work is centered on creating elevated, highly personal spaces that enhance both lifestyle and long-term value. Blending scientific precision with creative intuition, she brings together function, artistry and thoughtful detail to create interiors that are as purposeful as they are beautiful. For Sharefa, every project begins with listening. She believes the most successful spaces evolve with the people who inhabit them, supporting the way they live, gather, entertain and retreat. Her vision is simple: to create spaces that feel deeply personal, beautifully considered and unmistakably like home."],
  nameText: "Sharefa’s diverse background and extensive global travel have deeply influenced her design perspective, inspiring a layered and culturally informed approach to residential, hospitality, commercial, and retail environments. Her work is centered on creating elevated, highly personal spaces that enhance both lifestyle and long-term value. Blending scientific precision with creative intuition, she brings together function, artistry, and thoughtful detail to create interiors that are as purposeful as they are beautiful."
}];
export default function FoundersEditorial() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="founderseditorial" data-nav="light" className="bg-background text-foreground relative w-full py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          {/* Left Column: Sticky Editorial Portrait */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <motion.div initial={shouldReduceMotion ? {
              opacity: 1
            } : {
              opacity: 0,
              y: 20
            }} whileInView={shouldReduceMotion ? {
              opacity: 1
            } : {
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.2
            }} transition={{
              duration: 0.8,
              ease: "easeOut"
            }} className="overflow-hidden bg-muted">
                <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/founder_studio_portrait.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1781435/img/founder_studio_portrait.webp-wvc-sizes" alt="Studio founder standing elegantly in an editorial architectural doorway" loading="lazy" decoding="async" className="w-full h-auto object-contain grayscale transition-transform duration-700 hover:scale-102" src="https://included-grizzly.10web.cloud/wp-content/uploads/2026/09/profile-pic.png" />
              </motion.div>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-muted-foreground text-xs font-serif italic">
                  United States & Canada
                </span>
              </div>
            </div>
          </div>

          {/* Right Column: Editorial Multi-Paragraph Biographies */}
          <div className="lg:col-span-7 flex flex-col space-y-20 md:space-y-24">
            {founders.map((founder, index) => <motion.article key={founder.name} data-index={index} initial={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 0,
            y: 24
          }} whileInView={shouldReduceMotion ? {
            opacity: 1
          } : {
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.7,
            delay: index * 0.05,
            ease: "easeOut"
          }} className="flex flex-col space-y-6">
                <header className="space-y-1.5"></header>

                <div className="space-y-5 text-muted-foreground font-serif text-sm sm:text-base leading-relaxed tracking-normal">
                  {founder.paragraphs.map((para, pIndex) => <p key={pIndex} className="leading-7">
                      {para}
                    </p>)}
                </div>

                {index !== founders.length - 1}
              </motion.article>)}
          </div>
        </div>
      </div>
    </section>;
}